import store from 'store';
import { ONBOARDING_REDIRECTION_PAGE } from 'utils/CONSTANT';
import history from 'utils/History';
import { RESET_UPI_DATA, RESET_UPI_STEP, SET_HOME_MODAL_VISIBILITY, SET_ONBOARDING_REDIRECTION_PAGE } from 'Slices';
import { GetCustomerSettlementAccount, GetSettlementAccount, ValidateSettlementAccount } from 'Services';
import { isEmpty } from './Utils';

export const deviceBindingRedirectionHandle = (redirectToSource = false) => {
	const { onBoardingRedirection } = store.getState()?.App;
	store.dispatch(RESET_UPI_STEP());
	store.dispatch(RESET_UPI_DATA());
	switch (onBoardingRedirection.source) {
		case ONBOARDING_REDIRECTION_PAGE.PROFILE:
			store.dispatch(SET_ONBOARDING_REDIRECTION_PAGE({}));
			history.push({
				pathname: '/account/bank-account-details',
				search: `?bank-account-id=${onBoardingRedirection.searchParam}`,
			});
			break;
		case ONBOARDING_REDIRECTION_PAGE.MANDATE:
			if (redirectToSource) {
				store.dispatch(SET_ONBOARDING_REDIRECTION_PAGE({}));
				history.push({ pathname: '/upi/auto-pay-landing' });
			} else {
				store.dispatch(SET_HOME_MODAL_VISIBILITY({ importantCheckpointModal: true }));
			}
			break;
	}
};

export const checkSettlementAccountMatch = async (onBoardingRedirection: any) => {
	const settlementAccount = store.getState()?.settlementAccount;
	const customerSettlementAccount = store.getState()?.customerSettlementAccount;
	let bankData;
	switch (onBoardingRedirection) {
		case ONBOARDING_REDIRECTION_PAGE.PROFILE:
			if (!isEmpty(customerSettlementAccount.data)) bankData = customerSettlementAccount?.data?.data;
			else {
				const data = await GetCustomerSettlementAccount();
				bankData = (data as any)?.data;
			}

			break;
		case ONBOARDING_REDIRECTION_PAGE.MANDATE:
			if (!isEmpty(settlementAccount.data)) bankData = settlementAccount?.data?.data;
			else {
				const data = await GetSettlementAccount();
				bankData = (data as any)?.data;
			}
			break;
	}
	const isMatchedSettlementAccount = await ValidateSettlementAccount({
		account_provider_id: bankData?.providerId,
		account_no: bankData?.account,
		ifsc: bankData?.ifsc,
	});
	return isMatchedSettlementAccount?.settlement_account_exists;
};
